import isEqual from 'fast-deep-equal';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createWithEqualityFn } from 'zustand/traditional';

import { IUsersState, IUserStateActions, usersState } from '@p/security/users/store/store.type';

import { groupTabs } from '@t/p/security/users/tabs.enums';

const action = (name: keyof IUserStateActions) => ({ type: `users/${name}` });

const initialState: IUsersState = {
  addUser: false,
  isOpenClientGroup: false,
  isOpenFilter: false,
  isOpenUserInfo: false,
  tab: groupTabs.All,
};

export const userStore = createWithEqualityFn<usersState>()(
  immer(
    devtools((set, _) => ({
      ...initialState,
      reset: () =>
        set(
          () => ({
            tab: groupTabs.All,
          }),
          false,
          action('reset')
        ),

      setAddUser: (value) => set({ addUser: value }, false, action('setAddUser')),
      setIsOpenClientGroup: (value) => set({ isOpenClientGroup: value }, false, action('setIsOpenClientGroup')),
      setIsOpenFilter: (value) => set({ isOpenFilter: value }, false, action('setIsOpenFilter')),
      setIsOpenUserInfo: (value) => set({ isOpenUserInfo: value }, false, action('setIsOpenUserInfo')),
      setTab: (value) => set({ tab: value }, false, action('setTab')),
    }))
  ),
  isEqual
);
